import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuthContext } from "../../auth-state";
import { SettingR } from "../pages/settings/route";
import { SmartApplyR } from "../pages/smart-apply/route";
import { SurveyR } from "../pages/surveys/route";
import { TtzkPortalR } from "../pages/ttzk-portal/route";

export const RedirectRoutes: React.FC = () => {
  const authAcc = useAuthContext();
  if (!authAcc.lastChecked) {
    return <div />;
  }

  return (
    <Route
      render={() => {
        if (authAcc.isProductAvailable("SmartApply")) {
          return <Redirect to={SmartApplyR.Applications.link({})} />;
        }

        if (authAcc.isProductAvailable("Survey")) {
          return <Redirect to={SurveyR.Surveys.link({})} />;
        }

        if (authAcc.isPortalAvailable()) {
          return <Redirect to={TtzkPortalR.Home.link({})} />;
        }

        if (authAcc.isProductAvailable("BoothReserve")) {
          window.location.assign(
            `${
              process.env.REACT_APP_ENVIRONMENT === "local"
                ? "http://localhost:4100"
                : window.location.origin
            }/booth-reserve/`,
          );
        }
        if (authAcc.isProductAvailable("MadoguchiEditor")) {
          window.location.assign(
            `${
              process.env.REACT_APP_ENVIRONMENT === "local"
                ? "http://localhost:3004"
                : window.location.origin
            }/madoguchi-editor/`,
          );
        }
        if (authAcc.isProductAvailable("AIStudio")) {
          window.location.assign(
            `${
              process.env.REACT_APP_ENVIRONMENT === "local"
                ? "http://localhost:4901"
                : window.location.origin
            }/aistudio/`,
          );
          return;
        }
        if (authAcc.isProductAvailable("Call")) {
          window.location.assign(
            `${
              process.env.REACT_APP_ENVIRONMENT === "local"
                ? "http://localhost:4200"
                : window.location.origin
            }/call/`,
          );
          return;
        }
        if (authAcc.isProductAvailable("NinteiShoukai")) {
          window.location.assign(
            `${
              process.env.REACT_APP_ENVIRONMENT === "local"
                ? "http://localhost:6803"
                : `${window.location.origin}/nintei-shoukai/`
            }`,
          );
          return;
        }
        if (authAcc.hasPermissions("users.create")) {
          return <Redirect to={SettingR.Users.link({})} />;
        }
        return <Redirect to={SettingR.MyAccount.link({})} />;
      }}
    />
  );
};
